/**
 * @generated SignedSource<<62457ac9459b80db612bc0a9f7c5b5e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type deleteSCardMutation$variables = {
  backLang?: string | null;
  id: string;
};
export type deleteSCardMutation$data = {
  readonly deleteSCard: {
    readonly id: string;
    readonly sCards: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null;
};
export type deleteSCardMutation = {
  response: deleteSCardMutation$data;
  variables: deleteSCardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "backLang"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Source",
    "kind": "LinkedField",
    "name": "deleteSCard",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "backLang",
            "variableName": "backLang"
          }
        ],
        "concreteType": "SCard",
        "kind": "LinkedField",
        "name": "sCards",
        "plural": true,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteSCardMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "deleteSCardMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "6c3073bc9426150902cf30829535457b",
    "id": null,
    "metadata": {},
    "name": "deleteSCardMutation",
    "operationKind": "mutation",
    "text": "mutation deleteSCardMutation(\n  $id: ID!\n  $backLang: String\n) {\n  deleteSCard(id: $id) {\n    id\n    sCards(backLang: $backLang) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "53956e362909a947c4d0677edae5bd7c";

export default node;
